/**
 * Arabic labels for the common Channex review-score categories (fallback: the raw key) — one copy for the
 * unit tab's review cards and the Reviews page's reply cards, so a category reads the same everywhere.
 */
const OTA_CATEGORY_AR = {
  // Airbnb sends `clean` (seen on prod, 13 Sep), Booking.com `cleanliness`.
  clean: 'النظافة', cleanliness: 'النظافة', communication: 'التواصل', location: 'الموقع',
  accuracy: 'الدقة', checkin: 'تسجيل الوصول', check_in: 'تسجيل الوصول',
  value: 'القيمة', comfort: 'الراحة', staff: 'الطاقم', facilities: 'المرافق',
  wifi: 'الإنترنت'
};

export const getOtaCategoryLabel = (key) => OTA_CATEGORY_AR[String(key).toLowerCase()] || key;
